import * as React from "react";
import { Divider, Segment } from "semantic-ui-react";

import { ReportApprovalStatusTypes, ReportDetails } from "../reportsCommon";

interface Props {
    reportDetails: ReportDetails | null;
}

export const EmployeeReleaseReportWithCommentsInfo: React.FunctionComponent<Props> = (props: Props) => {

    const details = props.reportDetails;

    if (!details) {
        return null;
    }

    const isApprovedWithComments = details.approvalState === ReportApprovalStatusTypes.ApprovedWithComments;

    if (details.reportChangesBlocked && details.releaseReportComments && isApprovedWithComments) {
        return (
            <>
                <Divider />
                <Segment basic>
                    <p><b>Employee comments:</b></p>
                    <p>{details.releaseReportComments}</p>
                </Segment>
            </>
        );
    }

    return null;
};
